var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMotorOil(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 175 54",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    cx: "49.835%",
    cy: "3.438%",
    fx: "49.835%",
    fy: "3.438%",
    r: "137.632%",
    gradientTransform: "matrix(1 0 0 .72059 0 .01)",
    id: "b"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EC5F65",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB5C62",
    offset: "9.08%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA5559",
    offset: "18.49%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9474B",
    offset: "28.06%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E73537",
    offset: "37.73%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E41821",
    offset: "47.39%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3051B",
    offset: "50%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BD1821",
    offset: "80%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B31B28",
    offset: "85.26%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#972138",
    offset: "95.64%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A233F",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "50.024%",
    cy: "50.021%",
    fx: "50.024%",
    fy: "50.021%",
    r: "22.028%",
    gradientTransform: "matrix(.91351 -.2297 1.2004 1.52192 -.557 -.146)",
    id: "d"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    stopOpacity: 0.95,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M19.531 0c5.855 13.883 19.408 21.136 19.342 35.005C38.823 45.515 30.172 54 19.531 54S.241 45.515.19 35.005C.124 21.135 13.676 13.883 19.53 0",
    id: "a"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.009 32.64c0-6.378 4.245-10.63 10.712-10.63 6.468 0 10.741 4.252 10.741 10.63s-4.273 10.63-10.74 10.63-10.714-4.252-10.714-10.63m14.274 0c0-2.7-1.425-4.482-3.562-4.482-2.108 0-3.532 1.781-3.532 4.482 0 2.7 1.424 4.482 3.532 4.482 2.137 0 3.562-1.781 3.562-4.482m25.072-4.31h-5.1v14.366H63.16V28.33h-5.128v-5.746h17.322zm.57 4.31c0-6.378 4.245-10.63 10.712-10.63 6.468 0 10.741 4.252 10.741 10.63s-4.273 10.63-10.74 10.63-10.713-4.252-10.713-10.63m14.273 0c0-2.7-1.424-4.482-3.56-4.482-2.11 0-3.534 1.781-3.534 4.482 0 2.7 1.425 4.482 3.533 4.482 2.137 0 3.561-1.781 3.561-4.482m20.001 10.056-2.878-5.344h-1.14v5.344h-7.094V22.584h8.946c5.556 0 8.775 2.73 8.775 7.384 0 2.442-.883 4.338-2.478 5.602l4.16 7.126zm-4.018-10.918h1.396c1.253 0 2.022-.66 2.022-1.81s-.769-1.81-2.08-1.81h-1.338zm19.858.862c0-6.378 4.245-10.63 10.712-10.63 6.468 0 10.741 4.252 10.741 10.63s-4.273 10.63-10.74 10.63-10.713-4.252-10.713-10.63m14.274 0c0-2.7-1.425-4.482-3.562-4.482-2.108 0-3.533 1.781-3.533 4.482 0 2.7 1.425 4.482 3.533 4.482 2.137 0 3.562-1.781 3.562-4.482m8.888-10.056h7.095v20.112H149.2zm25.044 14.366v5.746H159V22.584h7.094V36.95z",
    fill: "#032B56",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(.012)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "c",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    mask: "url(#c)",
    d: "M0 .01h38.912v54H0z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#032B56",
    fillRule: "nonzero",
    d: "M9.548 23.04h7.108l2.59 10.174h.115L22.01 23.04h7.05l5.44 19.894h-7.684l-2.13-8.725h-.115l-2.13 8.725h-6.273l-2.072-8.583h-.115l-2.216 8.583H4.108z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.553 20.262c4.012 9.836 4.068 19.08.126 20.648s-10.39-5.135-14.402-14.97-4.067-19.082-.125-20.65 10.39 5.135 14.401 14.97",
    fill: "url(#d)",
    fillRule: "nonzero"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMotorOil);
export default __webpack_public_path__ + "static/media/motor-oil.fd0b1404dd0e462367af5062fb03bb9b.svg";
export { ForwardRef as ReactComponent };